import { createAuth0 } from "@auth0/auth0-vue";

const getStoredLanguage = (): string | undefined => {
  const storedLanguage = localStorage.getItem("preferredLanguage");
  const searchParams = new URLSearchParams(window.location.search);
  const uiLocales = searchParams.get("ui_locales");
  return uiLocales || storedLanguage || undefined;
};

export const auth0Init = createAuth0(
  {
    domain: "https://auth.dpa-id.de",
    clientId: import.meta.env.VITE_AUTH0_CLIENTID,
    cacheLocation: "localstorage",
    authorizationParams: {
      redirect_uri: window.location.origin,
      scope:
        "openid profile email address phone offline_access read:current_user",
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      responseType: "token id_token",
      ui_locales: getStoredLanguage(),
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
  },
  // the plugin would router.push() after the callback, racing the initial
  // navigation; accessGuard handles the callback instead
  { skipRedirectCallback: true },
);
